import styled, { css } from 'styled-components';

import colors from 'utils/colors';
import device from 'utils/device';

import { Button } from '../Button';

export const IconsWrapper = styled.div`
  display: flex;
`;

export const FeedbackWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;

  button + button {
    margin: 24px 0 0 0;
  }

  @media ${device.isTabletAndAbove} {
    flex-direction: row-reverse;
    justify-content: flex-end;

    button + button {
      margin: 0 24px 0 0;
    }
  }
`;

export const ButtonWrapper = styled(Button)`
  @media ${device.isTabletAndAbove} {
    min-width: 200px;
  }
`;

export const ThumbWrapper = styled.button<{ selected?: boolean; disabledStyle?: boolean }>`
  position: relative;
  height: 80px;
  width: 80px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid ${colors.blueGrey};
  border-radius: 1px;
  cursor: pointer;
  background: none;
  user-select: none;

  ${props =>
    props.disabledStyle &&
    css`
      background-color: ${colors.darkGrey10};
      border: 1px solid ${colors.darkGrey75};
      padding: 1px;
      span {
        color: #707070;
      }
    `}

  ${props =>
    props.selected &&
    css`
      border: 2px solid ${colors.orange};
      span {
        color: ${colors.orange};
      }
    `};

  &:first-child {
    margin-right: 20px;
  }

  &:active,
  &:focus {
    outline: none;
  }
`;

export const CircleTickWrapper: React.FC = styled.div`
  position: absolute;
  width: 20px;
  top: -8px;
  right: -8px;
`;

interface SpacerProps {
  space: number;
}

export const Spacer = styled.div<SpacerProps>`
  margin-bottom: ${props => `${props.space}px`};
`;
